import { Component, ReactNode } from 'react';
import { ConnectedProps, connect } from 'react-redux';

import { showModal } from 'modules/main/store/ducks/modal.actions';

type OwnProps = {
  type: 'warning' | 'danger';
  title?: string;
  buttonText: string;
  body?: ReactNode;
  onConfirm: () => Promise<unknown>;
  render: (arg0: { showModal: () => void }) => ReactNode;
  extraButtons?: ReactNode;
  'data-qa-id'?: string;
};

type Props = OwnProps & PropsFromRedux;

class ShowConfirmationModal extends Component<Props> {
  showModal = () => {
    const { type, title, buttonText, body, onConfirm, extraButtons } =
      this.props;
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/destructuring-assignment
    this.props.showModal('CONFIRMATION', {
      type,
      title,
      buttonText,
      body,
      onConfirm,
      extraButtons,
      // TODO: Fix this the next time the file is edited.
      // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
      // eslint-disable-next-line react/destructuring-assignment
      'data-qa-id': this.props['data-qa-id'],
    });
  };

  render() {
    return (
      <>
        {
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/destructuring-assignment
          this.props.render({
            showModal: this.showModal,
          })
        }
      </>
    );
  }
}

const connector = connect(null, { showModal });

type PropsFromRedux = ConnectedProps<typeof connector>;

// eslint-disable-next-line import/no-default-export
export default connector(ShowConfirmationModal);
